import { take } from 'lodash-es';
import { Link } from 'react-router';
import { ContactListItem } from '@/components/contacts/contact-list/contact-list-item';
import type { Group } from '@/models/group/group-info';
import ROUTES from '@/routes';

type Props = {
  count?: number;
  groups: Group[];
};

export default function CommonGroupBlock({ groups, count = 3 }: Props) {
  return (
    <div className='flex flex-1 flex-col items-stretch'>
      {take(groups, count).map((group) => (
        <Link
          key={group.ID}
          to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: group.ID } })}>
          <ContactListItem
            item={group}
            className='px-0'
            arrow
          />
        </Link>
      ))}
    </div>
  );
}
